// extracted by mini-css-extract-plugin
export default {"reports":"looU142nBop8eMGboOch","reportBlock":"pQDhZ0g6Y01jKXu4K0ej"};